export default function description() {
    return (
        <div className="card__description-basic">
            <div className="card__description">
                <p className="card__description-title">
                    Загальна характеристика
                </p>
                <p className="card__description-text">
                    АЯКС (НС DFSP) — це один із найврожайніших гібридів соняшнику у класичній технології, який поєднує максимальний потенціал продуктивності з високою посухостійкістю. Гібрид створений для господарств, які прагнуть отримати максимальний результат без використання IMI або SUMO систем.
                </p>
                <p className="card__description-text">
                    Він відзначається потужним розвитком рослин, стабільністю у різних умовах та високою адаптивністю до кліматичних змін.
                </p>
                <p className="card__description-title">Основні переваги</p>
                <ol className="card__description-list">
                    <li className="card__description-numbering">Дуже високий потенціал урожайності — до 6,0 т/га</li>
                    <li className="card__description-numbering">Один із найврожайніших гібридів у класичній технології</li>
                    <li className="card__description-numbering">Висока посухостійкість</li>
                    <li className="card__description-numbering">Стійкість до вовчка — 5 рас (A–E)</li>
                    <li className="card__description-numbering">Потужна вегетативна маса</li>
                    <li className="card__description-numbering">Висока стабільність результату</li>
                </ol>
                <table className="card__description__table">
                    <tr>
                        <td className="card__description__td">Період вегетації</td>
                        <td className="card__description__th-index">109–114 днів</td>
                    </tr>
                    <tr>
                        <td className="card__description__td">Олійність:</td>
                        <td className="card__description__th-index">50–52%</td>
                    </tr>
                    <tr>
                        <td className="card__description__td card__description__td--link">Висота рослин</td>
                        <td className="card__description__th-index">180–200 см</td>
                    </tr>
                </table>
                <p className="card__description-title">
                    Рекомендації по густоті
                </p>
                <ol className="card__description-list">
                    <li className="card__description-numbering">За достатнього зволоження: 65–70 тис. рослин/га</li>
                    <li className="card__description-numbering">У посушливих умовах: 50–55 тис. рослин/га</li>
                </ol>
                <div className="card__description-title">Стійкість та толерантність</div>
                <ol className="card__description-list">
                    <p className="card__description-text">
                        Стійкість:
                    </p>
                    <li className="card__description-numbering">Осипання, холодостійкість, посухостійкість — 9/10</li>
                    <li className="card__description-numbering">Вилягання — 8/10</li>
                    <p className="card__description-text">
                        Толерантність до хвороб:
                    </p>
                    <li className="card__description-numbering">Біла гниль, вугільна гниль, фомопсис — 9/10</li>
                    <li className="card__description-numbering">Фомоз, альтернаріоз, септоріоз, сіра гниль, іржа — 8/10</li>
                    <li className="card__description-numbering">Пероноспороз — 7/10</li>
                </ol>
                <div className="card__description-title">Рекомендовані зони вирощування</div>
                <p className="card__description-text">
                    АЯКС демонструє найкращі результати у Степу та Лісостепу України, але може ефективно вирощуватись і в інших регіонах за дотримання технології.
                </p>
                <div className="card__description-title">Рекомендації щодо вирощування</div>
                <p className="card__description-text">
                    АЯКС — це гібрид інтенсивного типу, який максимально розкриває потенціал за високого агрофону. Рекомендується використання стандартної системи захисту рослин та дотримання сівозміни. Гібрид добре реагує на удобрення та сучасні агротехнології.
                </p>
                <p className="card__description-text">
                    АЯКС — це вибір для тих, хто хоче максимальний урожай у класичній технології. Ідеальний варіант для господарств, орієнтованих на високий прибуток і інтенсивне виробництво.
                </p>
            </div>
            <div className="card__description-preference">
                <div className="aside__title--new">Головні переваги</div>
                <div className="asede__head">
                    <div className="aside__block">Високий потенція урожайності</div>
                    <div className="aside__block">Найкращу віддачу забезпечує на родючих грунтах</div>
                    <div className="aside__block">Один із найбільш високоврожайних гібридів з високим вмістом олії</div>
                </div>
            </div>
        </div>
    );
}
